import type {ReactNode} from 'react';

import {PreAuthIllustratedLayout} from '../pre-auth-illustrated-layout';

import {CompoundTitle} from './compound-title';
import {AUTH_LINK_VARIANTS} from './consts';
import {LeadBoardImage} from './lead-board-image';
import {MainHeader} from './main-header';
// @ts-expect-error
import signupData from './signup';

import layoutStyles from '../pre-auth-illustrated-layout.module.css';

export type SignupData = {
    title: string;
    reviewSectionTitle: string;
};

interface Props {
    form: ReactNode;
}

export function PreAuthLayoutV2(props: Props) {
    const data: SignupData = signupData;

    return (
        <PreAuthIllustratedLayout
            illustration={
                <>
                    <CompoundTitle title={data.title} />
                    <div className={layoutStyles['illustration']}>
                        <LeadBoardImage />
                    </div>
                </>
            }
        >
            <div className={layoutStyles['left-header']}>
                <MainHeader authLinkVariant={AUTH_LINK_VARIANTS.SIGN_IN} />
            </div>
            <div className={layoutStyles['left-mobile-title']}>
                <CompoundTitle title={data.title} />
            </div>
            <div className={layoutStyles['left-main']}>{props.form}</div>
        </PreAuthIllustratedLayout>
    );
}
